/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { WhatsAppAccountShowPathParams, WhatsAppAccountShowResponse } from '../types/WhatsAppAccountShow'

/**
 * GET /organisations/:organisationId/whatsapp-account
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::show
 */
export async function whatsAppAccountShow(
	organisationId: WhatsAppAccountShowPathParams['organisationId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppAccountShowResponse>> {
	return axiosInstance.get(`/organisations/${organisationId}/whatsapp-account`, config)
}
